import { getApplicationAgent } from '@app/store/actions/contexts/applicationAgent'
import { configSelector } from '@app/store/slices/config'
import { localeSelector } from '@app/store/slices/locale'
import { shortSessionUuidSelector } from '@app/store/slices/short_session'
import { createThunk } from '@app/store/thunk'

/**
 * Shared request headers. The `Authorization` Bearer is intentionally absent:
 * it is resolved per-request from the supervision-aware auth session
 * (see `ApiDispatcher`), so it can be refreshed and
 * never goes stale here.
 *
 * `anonymous` drops the three that identify who is asking; what is left describes
 * the request itself, so a response fetched this way is the same for everyone and
 * may be cached across viewers.
 */
export const headers = (options?: { anonymous?: boolean }) =>
  createThunk<{ [key: string]: string }>((dispatch, getState) => {
    const config = configSelector(getState())
    const caller: { [key: string]: string } = options?.anonymous
      ? {}
      : {
          'X-Kidsout-Session-Id': shortSessionUuidSelector(getState()),
          'X-Kidsout-App-Request-Id': config.appRequestId,
          'X-Request-Id': config.appRequestId,
        }
    return {
      ...caller,
      'Accept-Language': localeSelector(getState()),
      'Application-Agent': dispatch(getApplicationAgent()).agent,
    }
  })
